/**
 * THE PERIOD THE PLANS ARE COMPARED OVER, SAID ONCE (owner, 25 Oct 2026).
 *
 * The plans are ranked on what they leave the family after the client's horizon, so a different horizon can
 * put a different plan first. The owner ruled against a control for the period inside the year-by-year window
 * ("you are potentially taking them somewhere completely different") and asked for a line instead. It sits in
 * the year-by-year window's footer and in every module's Explain this, in the same words.
 */
export function comparedOverSentence(years: number): string {
    const n = Math.max(1, Math.round(Number(years) || 0));
    return `These plans are compared over ${n} ${n === 1 ? 'year' : 'years'}. Over a longer or shorter period, a different plan can come out ahead.`;
}
